import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import {NetworkServerModel} from "../../models/network-server.model";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {HttpService} from "../../services/http.service";
import {ApiEndpoints} from "../../services/api-endpoints";

@Component({ standalone: false, 
  selector: 'app-input-checkbox',
  templateUrl: 'input-checkbox.component.html',
})
export class InputCheckboxComponent implements OnInit, OnDestroy {

  public networkServerModel: NetworkServerModel;
  public errorMessage;
  public hasError = false;
  isAdmin: boolean = false;
  inputIsDisable = true;
  inputIsHidden = false;
  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  @Input() saveType;
  @Input() inputValue;
  @Input() virtId;
  @Input() validationType;
  @Input() formType;
  @Input() label;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  constructor(private userVerificationService: UserVerificationService,
                private http: HttpClient,
                private httpService: HttpService) {

      this.networkServerModel = new NetworkServerModel();
      this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick(inputCheck) {
    inputCheck.classList.remove(...this.class);
    this.hasError = false;
    this.inputIsDisable = false;
    this.inputIsHidden = true;
    inputCheck.classList.remove('disabled');
  }

  inputOnSave(inputCheck) {
    let tempValue = inputCheck.checked;
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    switch (this.saveType) {
      case 'heliumMember':
        url = ApiEndpoints.UPDATE_HELIUM_MEMBER;
        body = {
          "virtId": this.virtId,
          "heliumMember": tempValue
        };
        break;
    }
    this.http.post<any>(url, body, options).subscribe(
      data => {
        this.inputIsDisable = true;
        this.inputValue = tempValue;
        inputCheck.checked = tempValue;
        this.inputIsHidden = false;
        this.hasError = false;
        this.errorMessage = "";
        inputCheck.classList.add('disabled');
      },
      error => {
        try {
          let err = JSON.parse(error._body);
          this.errorMessage = JSON.stringify(err.Description);
        } catch(ex) {
          this.errorMessage = "An error has occured!"
        } finally {
          this.hasError = true;
        }
      }
    );
  }

  inputOnCancel(inputCheck) {
    inputCheck.checked = this.inputValue;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.hasError = false;
    inputCheck.classList.add('disabled');
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }

}
